<template>
    <!-- BEGIN: Top Bar -->
    <div class="file box rounded-md px-5 pt-8 pb-5 px-3 sm:px-5 relative zoom-in">
        <a :href="data.archivo_ruta" target="_blank" class="w-3/5 file__icon file__icon--file mx-auto">
            <div class="file__icon__file-name">
                {{ data.archivo_ruta | extension }}
            </div>
        </a>
        <a :href="data.archivo_ruta" target="_blank" class="block font-medium mt-4 text-center">{{data.title}}</a>
        <div class="absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto">
            <a class="dropdown-toggle w-5 h-5 block" href="javascript:;">
                <MoreVerticalIcon class="w-5 h-5 text-gray-500" />
            </a>
            <div class="dropdown-box w-40">
                <div class="dropdown-box__content box dark:bg-dark-1 p-2">
                    <a target="_blank" :href="data.archivo_ruta" download class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2  rounded-md">
                        <DownloadIcon class="w-4 h-4 mr-2" /> Descargar
                    </a>
                </div>
                <div v-if="isAdmin" class="dropdown-box__content box dark:bg-dark-1 p-2">
                    <button @click="remove(data.num)" class="w-full flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2  rounded-md">
                        <XIcon class="w-4 h-4 mr-2" /> Eliminar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- END: Top Bar -->
</template>
<script>
export default {
    props: ["data", "index"],
    watch: {},
    computed: {
        isAdmin() {
            return globalThis.bus.admin;
        }
    },
    filters: {
        extension(value) {
            var extension = value.split(".") ? value.substring(value.lastIndexOf(".") + 1) : "FILE";
            return extension ? extension.toUpperCase() : "FILE";
        }
    },
    mounted() {},
    data() {
        return {};
    },
    methods: {
        async remove(fileNum) {
            if (confirm('¿Está seguro? No se podra recuperar el archivo.')) {
                let data = { num: fileNum };
                let response = await CmsApi.hook('/hooks/save/', { 'action': 'eliminar_archivo', 'data': JSON.stringify(data) });
                if (response.success) {
                    window.bus.$emit("reloadDataFromServer", {});
                } else {
                    alert('No se pudo eliminar el archivo.');
                }
            }
        }
    }
};
</script>